/// <reference path="GamesFlashQuiz.js" />
/// <reference path="UrlTemplate.js" />
/// <reference path="TextResource.js" />
/// <reference path="gameUtils/EasierLevel.js" />

class GamesLeveledFlashQuiz extends GamesFlashQuiz {
	constructor(el, options) {
		super(el, options);
		this.level = this.options.level;
		this.medalMinLevel = this.options.medalMinLevel;
		this.progress = this.options.progress;
		this.setLevelInformation();
		this.blinkLength = this.options.blinkLength;
		this.nrOfBlinks = this.options.nrOfBlinks;
		this.isArcade = this.options.isArcade;
		this.screenId = '#levelUpScreen';
		this.medalBox = document.getElementById(this.options.medalBox).querySelector('img');
		this.levelText = document.getElementById(this.options.levelText);
		this.progressBar = document.getElementById(this.options.progressBar);
		this.menuBar = document.getElementsByClassName("menubar")[0];
		this.easierLevel = new EasierLevel(this.options, this.safeObserve.bind(this));

		if (options.nomedal == "true" || this.medalBox.src == "")
			this.medalBox.style.display = "none";

		this.setTaskText(new TextResource(this.options.trLoadingLevel).string());

		if (!document.querySelector(".mia-LevelUpScreen")) {
			const app = window.createVueApplication('legacy-level-up-screen');
			app.mount(this.el.querySelector(".mia-LegacyLevelUpScreen"));
		}

		waitForElementToBePresent(this.screenId).then(this.initializeLevelUpScreen.bind(this));
		this.easierLevel.initializeEasierLevel(this);
		waitForElementToBePresent(".mia-easierLevelConfirmButton").then(this.initializeLevelDown.bind(this));
	}

	initializeLevelUpScreen() {
		this.screenJQuery = jQuery(this.screenId);
		this.screenJQuery.find('.levelUpButton').on('click', this.onNextLevelOkClick.bind(this));
		this.screenJQuery.find('.lastLevelContinueButton').on('click', this.onNextLevelOkClick.bind(this));
		if (this.options.endingScreenShown) {
			this.showEndingScreen(this.options.endingScreenRobotSrc, this.options.endingScreenLevel, this.options.endingScreenMedalName, this.options.endingScreenAmountOfScoops);
		} else {
			this.hideLevelFinalScreen();
		}
	}

	setLevelInformation() {
		var nextMedalLevel = this.options.nextMedalLevel;
		if (nextMedalLevel > 0 && !(this.options.noNextMedal == "true")) {
			this.el.querySelector('.nextMedalArea').style.display = "inline-block";
			this.el.querySelector('.nextMedalText').innerHTML = 'after Level: ' + nextMedalLevel;
		} else {
			this.el.querySelector('.nextMedalArea').style.display = "none";
		}
	}

	customLoadEvent(json) {}

	showPage() {
		this.updateProgressBar();
		this.levelText.innerHTML = 'Level: ' + this.json.level;
		this.easierLevel.initializeEasierLevel(this);
		var nextMedalLevel = this.json.nextMedalLevel;
		if (nextMedalLevel > 0 && !this.json.noNextMedal) {
			this.el.querySelector('.nextMedalArea').style.display = "inline-block";
			var realNextMedalLevel = nextMedalLevel;
			if (realNextMedalLevel > 0 && realNextMedalLevel < this.json.level) {
				realNextMedalLevel = this.json.level;
			}
			this.el.querySelector('.nextMedalText').innerHTML = 'after Level: ' + realNextMedalLevel;
		} else {
			this.el.querySelector('.nextMedalArea').style.display = "none";
		}
	}

	initializeLevelDown(element) {
		this.safeObserve(element, 'click', this.onLevelDownClick.bind(this));
	}

	onNextLevelOkClick(ev) {
		if (typeof(ev) != 'undefined')
			ev.preventDefault();

		this.startNextLevel();
		this.handleProcessResult();
	}

	startNextLevel() {
		this.showPage();
		this.screenJQuery.find('.levelButtons').css("display", "flex");
		this.screenJQuery.find('.continueButton').css("display", "none");
		if (this.isArcade) {
			this.screenJQuery.find('.returnToArcadeButton').css("display", "none");
		} else {
			this.screenJQuery.find('.continueButton').css("display", "none");
		}
		this.hideLevelFinalScreen();
	}

	handleWrongAnswer() {
		var itemId = this.numberList[this.progress] | 0;
		if (this.progress > 0) {
			this.progress--;
			this.updateProgressBar();
		}

		var wrongAnswerPromise = new Promise(function(resolve, reject) {
			var url = new UrlTemplate(this.options.processAnswerUrl)
				.r('PLH_success', this.success)
				.r('PLH_Status', 2)
				.r('PLH_MedalType', this.medalType)
				.r('PLH_progress', this.progress)
				.r('PLH_itemId', itemId)
				.r('PLH_nquestion', -2).url;
			axios(url, {
				method: 'get'
			}).then((response) => {
				resolve(response.data)
			}).catch((error) => {
				reject(error);
			});
		}.bind(this));

		var blickingDelay = this.blinkLength * this.nrOfBlinks;
		new Promise(function(resolve) {
			setTimeout(resolve, blickingDelay);
		}).then(function() {
			this.setTaskText(new TextResource(this.options.trLoadingLevel).string());
			wrongAnswerPromise.then(this.onWrongAnswerSuccess.bind(this));
		}.bind(this));
	}

	onWrongAnswerSuccess(response) {
		this.json = response;
		if (this.json.numberList.length == 0 || this.json.textList[0] == undefined) {
			this.progress = 0;
			this.initFlashGame();
			return;
		}

		this.numberList = this.json.numberList;
		this.textList = this.json.textList;
		this.questionSoundPaths = this.json.questionSoundPaths;

		this.resetUI();
		this.setToClick(this.numberList[this.progress], this.textList[this.progress]);
		this.createAndReadAllTextToSpeech();
	}

	onSuccess(req) {
		var response = req.data;
		this.screenJQuery.find(".endingScreenButtons").css("display", "none");
		this.screenJQuery.find(".levelButtons").css("display", "flex");
		if (!this.isArcade && response.medalReceived) {
			this.showEndingScreen(response.medalRobotPictureSrc, this.json.level, response.medalName, response.amount);
			window.invalidateSelectedTask();
		} else if (response.medal != undefined && !response.medal.endsWith("games/medals/medal_none.svg")) {
			this.medalBox.src = this.json.medal;
			this.medalBox.style.display = "inline";
			this.screenJQuery.find('.header').text(new TextResource(this.options.trHeaderWithMedal).r("{number}", this.json.level).r("{medalType}", response.medalName).string());
			this.screenJQuery.find('.description').text(new TextResource(this.options.trDescriptionWithMedal).r("{number}", this.json.level).r('{coins}', response.amount).r("{medalType}", response.medalName).string());
			this.screenJQuery.find('.image').attr("src", response.robotPictureSrc);

			this.json.medal = "games/medals/medal_none.svg";
			if (this.json.challengeWasCompleted) {
				this.screenJQuery.find('.levelButtons').css("display", "none");
				this.screenJQuery.find('.challengeCompletedButtons').css("display", "inline-block");
			}
		} else {
			this.screenJQuery.find('.image').attr("src", response.robotPictureSrc);
			this.screenJQuery.find('.header').text(new TextResource(this.options.trHeaderWithoutMedal).r("{number}", this.json.level).string());
			this.screenJQuery.find('.description').text(new TextResource(this.options.trDescriptionWithoutMedal).r("{number}", this.json.level).r('{coins}', response.amount).string());
			this.screenJQuery.find('.levelButtons').css("display", "flex");
			if (this.isArcade) {
				this.screenJQuery.find('.returnToArcadeButton').css("display", "inline-block");
			}
		}
		this.json = response;

		var newLevel = 'Level: ' + this.json.level;

		//Level up
		if (this.progress == this.numberList.length && newLevel != this.levelText.innerHTML) {
			this.showLevelFinalScreen();
			this.removeAllListeners();
			this.updateProgressBar();
			if (this.json.amount == 0) {
				axios(new UrlTemplate(this.options.processAnswerUrl)
					.r('PLH_success', true)
					.r('PLH_Status', 2)
					.r('PLH_MedalType', this.medalType)
					.r('PLH_progress', this.progress)
					.r('PLH_itemId', -1)
					.r('PLH_nquestion', -2).url, {
					method: 'get'
				}).then(this.onSuccess.bind(this));
				return;
			}
			this.progress = 0;
			this.numberList = this.json.numberList;
			this.textList = this.json.textList;
			this.questionSoundPaths = this.json.questionSoundPaths;
			this.levelText.innerHTML = newLevel;

			var nextMedalLevel = this.json.nextMedalLevel;
			if (nextMedalLevel > 0 && !this.json.noNextMedal) {
				this.el.querySelector('.nextMedalText').innerHTML = 'after Level: ' + nextMedalLevel;
				this.el.querySelector('.medalIcon').src = this.json.nextMedalImageSource;
				this.el.querySelector('.nextMedalArea').style.display = "inline-block";
			} else {
				this.el.querySelector('.nextMedalArea').style.display = "none";
			}
		}
	}

	onLevelJumpSuccess(req) {
		try {
			this.json = req.data;
		} catch (e) {
			legacyGlobal.handleFailedAJAJRequest();
			return;
		}
		this.success = true;
		this.handleProcessResult();
		this.el.querySelector('.modal-header').querySelector(".mia-img").click();
		this.startNextLevel();
	}

	onLevelDownClick(ev) {
		this.easierLevel.setEasierLevel(this.options.levelJumpUrl, this.onLevelJumpSuccess.bind(this));
	}

	showLevelFinalScreen() {
		this.el.querySelector(".mia-ProgressSection").style.display = 'none';
		this.el.querySelector(".mia-svgGameContainer").style.display = 'none';
		this.el.querySelector(".questionContainer").style.display = 'none';
		var lessonIntro = this.el.querySelector(".mia-LessonIntro");
		if (lessonIntro) {
			lessonIntro.style.display = 'none';
		}
		this.changeFeedbackButtonVisibility(false);
		this.screenJQuery.css("display", "flex");
	}

	hideLevelFinalScreen() {
		this.el.querySelector(".mia-ProgressSection").style.display = '';
		this.el.querySelector(".mia-svgGameContainer").style.display = '';
		this.el.querySelector(".questionContainer").style.display = '';
		var lessonIntro = this.el.querySelector(".mia-LessonIntro");
		if (lessonIntro) {
			lessonIntro.style.display = '';
		}
		this.changeFeedbackButtonVisibility(true);
		this.screenJQuery.css("display", "none");
	}

	showEndingScreen(robotSrc, level, medalName, amount) {
		this.showLevelFinalScreen();

		this.screenJQuery.find(".endingScreenButtons").css("display", "flex");
		this.screenJQuery.find(".levelButtons").css("display", "none");

		this.screenJQuery.find(".title").text(this.options.trCongratulations);
		this.screenJQuery.find(".image").attr("src", robotSrc);
		this.screenJQuery.find(".header").text(this.options.trHeaderWithMedal.replace("{number}", level).replace("{medalType}", medalName));
		this.screenJQuery.find(".description").text(this.options.trDescriptionWithMedal.replace("{number}", level).replace('{coins}', amount).replace("{medalType}", medalName));
		this.screenJQuery.find(".repeatButton").on("click", this.onRepeatMedalClick.bind(this));
	}

	onRepeatMedalClick(event) {
		event.preventDefault();
		axios(new UrlTemplate(this.options.endingScreenRepeatMedalUrl).url, {
			method: 'get'
		}).then(this.initFlashGame.bind(this));
		this.progress = 0;
		this.hideLevelFinalScreen();
	}

	changeFeedbackButtonVisibility(show) {
		var feedbackButton = document.querySelector(".mia-GameFeedbackButton");

		if (feedbackButton !== null) {
			feedbackButton.style.display = show ? "flex" : "none";
		}
	}
}
